import type { ShippingsFilters } from '../types';

/**
 * Query keys factory for shippings
 * Follows TanStack Query best practices for hierarchical key structure
 */
export const shippingKeys = {
  all: ['shippings'] as const,
  lists: () => [...shippingKeys.all, 'list'] as const,
  list: (filters: ShippingsFilters) => [...shippingKeys.lists(), filters] as const,
  details: () => [...shippingKeys.all, 'detail'] as const,
  detail: (id: string) => [...shippingKeys.details(), id] as const,
  tracking: () => [...shippingKeys.all, 'tracking'] as const,
  canadaPostTracking: (trackingNumbers: string[]) =>
    [...shippingKeys.tracking(), 'canada-post', trackingNumbers] as const,
};
